var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicianPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0002,
    cy: 20,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8718 0C8.8976 0 0 8.955 0 20C0 31.045 19.8718 50 19.8718 50C19.8718 50 39.7436 31.045 39.7436 20C39.7436 8.955 30.846 0 19.8718 0ZM19.8718 7.5C23.3022 7.5 26.0817 10.2975 26.0817 13.75C26.0817 17.2025 23.3022 20 19.8718 20C16.4439 20 13.6619 17.2025 13.6619 13.75C13.6619 10.2975 16.4439 7.5 19.8718 7.5ZM10.5569 30C10.5569 24.2475 14.1562 20.625 19.8718 20.625C25.5874 20.625 29.1867 24.2475 29.1867 30H10.5569Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicianPin);
export default __webpack_public_path__ + "static/media/technicianPin.6330237dc2c5a0828c30b0c5b50bd164.svg";
export { ForwardRef as ReactComponent };